import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Tab, Tabs } from '~/components_to_be_packaged/tabs/tabs';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useRecentActivity } from '../providers';
import ComparisonsTab from './comparisons_tab';
import DocumentTab from './document_tab';
export const RecentActivityTabs = {
    DOCUMENTS: 'documents',
    DOCUMENT_COMPARISON: 'document-comparison',
};
const TabsView = () => {
    const { tab: activeTab } = useParams();
    const { hasPermission } = useUser();
    const navigate = useNavigate();
    const { setSelectedDocument } = useRecentActivity();
    const visibleTabNames = [
        RecentActivityTabs.DOCUMENTS,
        RecentActivityTabs.DOCUMENT_COMPARISON,
    ];
    const defaultTab = activeTab || RecentActivityTabs.DOCUMENTS;
    const index = visibleTabNames.findIndex(t => t === (activeTab !== null && activeTab !== void 0 ? activeTab : defaultTab));
    const activeTabIndex = index > -1 ? index : 0;
    const handleTabChange = (activeTabIndex) => {
        setSelectedDocument(null);
        navigate(`/recent-activity/${visibleTabNames[activeTabIndex]}`, { replace: true });
    };
    const tabs = [];
    if (hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS)) {
        tabs.push(React.createElement(Tab, { title: "Viewed Documents", icon: 'fa-regular fa-eye' },
            React.createElement(DocumentTab, null)));
    }
    if (hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS)) {
        tabs.push(React.createElement(Tab, { title: "Comparisons", icon: 'fa-regular fa-copy' },
            React.createElement(ComparisonsTab, null)));
    }
    return React.createElement(Tabs, { defaultTab: activeTabIndex, onTabChange: handleTabChange }, tabs);
};
export default TabsView;
